import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { updateAction } from '@/quote/util/update-action';
import { useStateMachine } from 'little-state-machine';

const keyMap = {
  U2FsdGVkX18TGGeZwGQKN9xL6JZGKYAt: 'wamo',
  remote: 'remote',
};

export const useGlobalLogo = () => {
  const router = useRouter();
  const [logoSource, setLogoSource] = useState('');
  const [logoSrc, setLogoSrc] = useState();
  const { state } = useStateMachine({ updateAction });

  useEffect(() => {
    const queryValue = keyMap[router.query.channel as string] || keyMap[router.query.theme as string] || '';
    const sessionValue = getQuoteChannel();
    const storeValue = state?.channel || state?.theme;

    const channel = queryValue || sessionValue || storeValue;

    setLogoSource(channel || 'jove');
  }, []);

  const saveQuoteChannel = () => {
    sessionStorage.setItem(
      'JOVE_CHANNEL_SOURCE',
      keyMap[router.query.channel as string] || ''
    );
  };

  const getQuoteChannel = () => {
    return sessionStorage.getItem('JOVE_CHANNEL_SOURCE') || sessionStorage.getItem('jove-theme') || '';
  };

  return {
    logoSource,
    logoSrc,
    setLogoSrc,
    saveQuoteChannel,
    getQuoteChannel,
  };
};
